/**
 * 순수하게 자바스크립트로 된
 * 날짜/시간 관련 유틸 함수 모듈
 */

const lookupDateByTodayMidnight = () => {
  const dt = new Date()

  const yyyy = dt.getFullYear()
  const mm = dt.getMonth()
  const dd = dt.getDate()

  return new Date(yyyy, mm, dd, 0, 0, 0)
}

const lookupDateTime = () => {
  const dt = new Date()

  const yyyy = dt.getFullYear()
  const mm = dt.getMonth()
  const dd = dt.getDate()
  const hh = dt.getHours()
  const minutes = dt.getMinutes()
  return new Date(yyyy, mm, dd, hh, minutes)
}

const TODAY_DATETIME = lookupDateByTodayMidnight()

const lookupDateYYYYMMDD = (yyyymmdd) => {
  if (yyyymmdd == undefined) {
    return lookupDateByTodayMidnight()
  }

  // if (EtnersCommonUtil.getMatchType(yyyymmdd) != 'STRING') {
  //   throw new Exception('잘못된 값입니다')
  // }

  const yyyy = Number(yyyymmdd.substring(0, 4))
  const mm = Number(yyyymmdd.substring(4, 6)) - 1
  const dd = Number(yyyymmdd.substring(6, 8))

  return new Date(yyyy, mm, dd, 0, 0, 0)
}

const lookupDateTimeHHMM = (hhmi) => {
  if (EtnersCommonUtil.getMatchType(hhmi) != 'STRING') {
    // throw new Exception('잘못된 값입니다')
  }

  const yyyy = TODAY_DATETIME.getFullYear()
  const mm = TODAY_DATETIME.getMonth()
  const dd = TODAY_DATETIME.getDate()

  const hh = hhmi.substring(0, 2)
  const mi = hhmi.substring(2, 4)

  return new Date(yyyy, mm, dd, hh, mi, 0)
}

const lookupDateTimeYYYYMMDDHHMM = (yyyymmdd, hhmi) => {
  if (EtnersCommonUtil.getMatchType(yyyymmdd) != 'STRING') {
    // throw new Exception('잘못된 값입니다')
  }

  if (EtnersCommonUtil.getMatchType(hhmi) != 'STRING') {
    // throw new Exception('잘못된 값입니다')
  }

  const yyyy = Number(yyyymmdd.substring(0, 4))
  const mm = Number(yyyymmdd.substring(4, 6)) - 1
  const dd = Number(yyyymmdd.substring(6, 8))

  const hh = hhmi.substring(0, 2)
  const mi = hhmi.substring(2, 4)

  return new Date(yyyy, mm, dd, hh, mi, 0)
}

const isEmpty = (arg) => {
  if (arg === undefined || arg === null || arg === 'null') {
    return true
  }

  if (arg instanceof Date) {
    return isNaN(arg.getTime());
  }

  const type = getMatchType(arg)

  let flag = false

  switch (type) {
    case 'NUMBER' :
      flag = false
      break
    case 'ARRAY' :
      flag = arg.length == 0
      break
    case 'STRING' :
      try {
        flag = arg.trim().length == 0
      } catch (e) {
        String.prototype.trim = function () {
          return this.replace(/^\s+|\s+$/g, '')
        }

        flag = arg.trim().length == 0
      }
      break
    case 'OBJECT' :
      try {
        flag = Object.keys(arg).length == 0
      } catch (e) {
        let count = 0

        for (const key in arg) {
          count++
        }

        flag = count == 0
      }
      break
  }

  return flag
}

const isNotEmpty = (arg) => {
  return !isEmpty(arg)
}

const dateToYYYYMMDD = function (date, pattern) {
  const yyyy = date.getFullYear(); const mm = convertTwoDigit(date.getMonth() + 1); const dd = convertTwoDigit(date.getDate())

  let returnValue = String.prototype.concat(yyyy, mm, dd)
  if (pattern) {
    returnValue = String.prototype.concat(yyyy, pattern, mm, pattern, dd)
  }

  return returnValue
}
const formatYYYYMMWithPattern = function (date,pattern){
  let returnVal = "-"
  if(date.length === 6){
    const yyyy = date.substring(0,4)
    const mm = date.substring(4,6)

    returnVal = String.prototype.concat(yyyy,pattern,mm)
  }

  return returnVal
}
const dateToYYYYMMDDHHMI = function (date) {
  const yyyy = date.getFullYear();
  const mm = convertTwoDigit(date.getMonth() + 1);
  const dd = convertTwoDigit(date.getDate())
  const HH = convertTwoDigit(date.getHours())
  const mi = convertTwoDigit(date.getMinutes())

  let returnValue = String.prototype.concat(yyyy, mm, dd,HH,mi)

  return returnValue
}

const dateToYYMMDD = function (date, pattern) {
  const yy = date.getFullYear().toString().substring(2,4); const mm = convertTwoDigit(date.getMonth() + 1); const dd = convertTwoDigit(date.getDate())

  let returnValue = String.prototype.concat(yy, mm, dd)
  if (pattern) {
    returnValue = String.prototype.concat(yy, pattern, mm, pattern, dd)
  }

  return returnValue
}

const dateToYYYYMM = function (date) {
  return date.getFullYear() + convertTwoDigit(date.getMonth() + 1)
}

const dateToMM = function (date) {
  return convertTwoDigit(date.getMonth() + 1) // 6 => 06
}

const dateToYYYYMMDDWithPoint = function (date, separator) {
  if (separator == undefined) {
    separator = ' '
  }

  return `${date.getFullYear()}${separator}${convertTwoDigit(date.getMonth() + 1)}${separator}${convertTwoDigit(date.getDate())}`
}

const convertTwoDigit = function (number) {
  if (number < 10) {
    return `0${number}`
  } else {
    return `${number}`
  }
}

const dateToHHMI = function (date) {
  return convertTwoDigit(date.getHours()) + convertTwoDigit(date.getMinutes())
}

const convertDateYYMMDD = function (dateStr) { //YYYYMMDD -> YY/MM/DD
  const resDate = dateStr.slice(2).replace(/(\d{2})(\d{2})(\d{2})/g, '$1/$2/$3')
  return resDate
}

const getToday = function () { // nowDate(yyyy-mm-dd)
  const date = new Date()
  const year = date.getFullYear()
  const month = ("0" + (1 + date.getMonth())).slice(-2)
  const day = ("0" + date.getDate()).slice(-2)
  return year + "-" + month + "-" + day
}

export default {
  lookupDateYYYYMMDD,
  lookupDateTimeHHMM,
  lookupDateTimeYYYYMMDDHHMM,
  dateToYYYYMMDDWithPoint,
  dateToYYYYMMDDHHMI,
  isEmpty,
  isNotEmpty,
  lookupDateByTodayMidnight,
  lookupDateTime,
  dateToYYMMDD,
  dateToYYYYMM,
  dateToYYYYMMDD,
  formatYYYYMMWithPattern,
  dateToMM,
  dateToHHMI,
  convertTwoDigit,
  convertDateYYMMDD,
  getToday
}
